/*
 * Fallback tenant / app identifiers used before the user logs in. The very
 * first discover call must carry X-App-ID (it becomes `clientId`), and
 * X-Tenant-ID so tenant-header middleware does not 400 before the body is
 * read. After authenticate, `authService.login` stores the real tenant via
 * `tokenStore.setTenantId(...)`.
 */
export const DEV_DEFAULTS = {
  tenantId:
    (import.meta.env.VITE_DEFAULT_TENANT_ID as string | undefined) ||
    'adc75548-c9b7-4962-9978-05114a71e856',
  appId:
    (import.meta.env.VITE_APP_ID as string | undefined) ||
    'f8f8cacd-63ab-4387-a1c7-cd24bf2610f9',
} as const;
